<template>
  <div class="document-edit-root">
    <div class="top-bar">
      <span class="top-bar-title">{{ caseName ? (caseName + ' - ') : '' }}{{ documentName || '文书编辑' }}</span>
      <el-button class="top-bar-back" type="text" @click="goBack">
        <i class="el-icon-arrow-left"></i> 返回案件
      </el-button>
    </div>
    <div class="main-layout">
      <!-- 左侧材料与段落 -->
      <div class="side-bar">
        <div class="side-action-bar">
          <el-button
            v-if="!llmGenerating && documentPath"
            type="primary"
            size="mini"
            @click="regenerateLlmDocument"
            style="margin-right: 12px;"
          >重新生成</el-button>
          <el-button
            v-if="documentFileUrl"
            type="success"
            size="mini"
            @click="downloadDocument"
          >下载文书</el-button>
        </div>
        <!-- 卡片化引用材料 -->
        <el-card class="side-card" shadow="hover">
          <div class="section material-section">
            <div class="section-title" style="display: flex; align-items: center; justify-content: space-between;">
              <span>引用材料</span>
              <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAddMaterial" style="margin-left:auto;"></el-button>
            </div>
            <el-table
              :data="materialList"
              style="width: 100%"
              highlight-current-row
              @row-click="handleMaterialRowClick"
              height="250"
              :show-header="false"
              ref="materialTable"
            >
              <el-table-column prop="materialName" label="材料名称" />
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click.stop="previewMaterial(scope.row)">预览</el-button>
                  <el-button type="text" size="mini" style="color: #f56c6c" @click.stop="removeMaterialRow(scope.row)">移除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-dialog title="添加案件材料" :visible.sync="showAddMaterialDialog" width="800px">
              <el-table
                :data="unaddedMaterialList"
                style="width: 100%"
                @selection-change="handleAddMaterialSelection"
                :row-key="row => row.materialId"
                height="300"
              >
                <el-table-column type="selection" width="50" />
                <el-table-column prop="materialName" label="材料名称" />
                <el-table-column prop="materialCategory" label="分类" />
              </el-table>
              <div slot="footer" class="dialog-footer">
                <el-button @click="showAddMaterialDialog = false">取消</el-button>
                <el-button type="primary" @click="addSelectedMaterials">添加</el-button>
              </div>
            </el-dialog>
            <!-- 材料预览弹窗 -->
            <el-dialog title="材料预览" :visible.sync="showPreviewMaterialDialog" width="70vw" top="3vh" class="material-preview-dialog">
              <div class="material-preview-container">
                <only-office
                  v-if="previewFileUrl"
                  :file-url="previewFileUrl"
                  :file-type="previewFileType"
                  :title="previewFileTitle"
                  :mode="'view'"
                  :container-style="'width:100%;height:100%;'"
                  :width="'100%'"
                  :height="'85vh'"
                />
              </div>
            </el-dialog>
          </div>
        </el-card>
        <!-- 卡片化文书段落 -->
        <el-card class="side-card paragraph-card" shadow="hover" style="margin-top: 16px;">
          <div class="section paragraph-section">
            <div class="section-title" style="display: flex; align-items: center; justify-content: space-between;">
              <span>文书段落</span>
              <el-switch
                v-model="showOnlyEditable"
                active-text="仅显示可维护"
                inactive-text="显示全部"
                :active-value="true"
                :inactive-value="false"
                style="margin-left: 12px;"
              />
            </div>
            <div class="paragraph-table-wrapper">
              <el-table :data="filteredParagraphList" style="width: 100%; height: 100%;" height="auto" class="paragraph-table">
                <el-table-column prop="paragraphName" label="段落名称" />
                <el-table-column prop="paragraphStatus" label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.paragraphStatus === 1">待生成</span>
                    <span v-else-if="scope.row.paragraphStatus === 2">已生成</span>
                    <span v-else>未知</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.isEditable === 1" type="text" size="mini" @click="editParagraph(scope.row)">维护</el-button>
                    <el-button v-if="scope.row.paragraphStatus === 2" type="text" size="mini" @click="viewParagraph(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 段落维护弹窗 -->
            <el-dialog :title="editingParagraph ? '维护段落：' + editingParagraph.paragraphName : '维护段落'" :visible.sync="showEditParagraphDialog" width="700px" top="10vh" class="paragraph-dialog">
              <div v-if="editingParagraph">
                <el-input
                  type="textarea"
                  v-model="editingParagraphContent"
                  :rows="16"
                  placeholder="请输入段落内容"
                  class="paragraph-dialog-textarea"
                />
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEditParagraph">取消</el-button>
                <el-button type="primary" @click="saveParagraphContent">保存</el-button>
              </div>
            </el-dialog>
            <!-- 段落查看弹窗 -->
            <el-dialog :title="viewingParagraph ? '查看段落：' + viewingParagraph.paragraphName : '查看段落'" :visible.sync="showViewParagraphDialog" width="700px" top="10vh" class="paragraph-dialog">
              <div v-if="viewingParagraph">
                <el-input
                  type="textarea"
                  :value="viewingParagraph.paragraphContent"
                  :rows="16"
                  readonly
                  class="paragraph-dialog-textarea"
                />
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="cancelViewParagraph">关闭</el-button>
              </div>
            </el-dialog>
          </div>
        </el-card>
      </div>
      <!-- 中间材料预览区 -->
      <div class="preview-area">
        <div v-if="!documentPath">
          <div class="llm-generate-center-area">
            <el-button v-if="!llmGenerating" class="llm-generate-btn" type="primary" :loading="llmGenerating" @click="generateLlmDocument">
              <i class="el-icon-magic-stick" style="font-size: 22px; margin-right: 8px;"></i>
              文书一键智能生成
            </el-button>
            <transition name="fade">
              <div v-if="llmGenerating" class="llm-generating-block">
                <i class="el-icon-loading llm-loading-icon"></i>
                <span class="llm-generating-text">文书正在智能生成中，请稍候...</span>
                <el-card class="llm-reasoning-card" style="margin-top:16px;">
                  <div ref="llmReasoningStream" class="llm-reasoning-stream">{{ llmReasoningList.join('') }}</div>
                </el-card>
              </div>
            </transition>
            <div v-if="llmParagraphs.length && !llmGenerating" style="margin-top: 24px;">
              <el-table :data="llmParagraphs" style="width: 100%;">
                <el-table-column prop="paragraphKey" label="段落标识" />
                <el-table-column prop="paragraphContent" label="生成内容" />
              </el-table>
            </div>
          </div>
        </div>
        <div v-if="documentPath" class="preview-area-wrapper">
          <!-- 右侧操作按钮已移除 -->
          <only-office
            :file-url="documentFileUrl"
            :file-type="'docx'"
            :title="documentName"
            :mode="'edit'"
            :container-style="'width:100%;'"
            :width="'1400px'"
            :height="'85vh'"
            :editor-config="{
              customization: {
                autosave: false,
                forcesave: true
              },
              callbackUrl: getOnlyofficeCallbackUrl()
            }"
            ref="onlyoffice"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import OnlyOffice from '@/components/OnlyOffice.vue'

export default {
  name: 'DocumentEdit',
  components: { OnlyOffice },
  data() {
    return {
      caseId: '',
      documentId: '',
      documentName: '',
      caseName: '',
      materialList: [],
      paragraphList: [],
      previewFileUrl: '',
      previewFileType: '',
      previewFileTitle: '',
      currentMaterialId: '',
      showAddMaterialDialog: false,
      unaddedMaterialList: [],
      addMaterialSelection: [],
      materialSelection: [],
      editingParagraph: null,
      editingParagraphContent: '',
      viewingParagraph: null,
      showOnlyEditable: true,
      showPreviewMaterialDialog: false,
      showEditParagraphDialog: false,
      showViewParagraphDialog: false,
      llmParagraphs: [],
      llmGenerating: false,
      documentPath: '',
      llmTaskTimer: null,
      llmTaskId: '',
      documentFileUrl: '',
      ws: null,
      wsSessionId: '',
      llmReasoningList: [],
    }
  },
  created() {
    this.caseId = this.$route.params.caseId
    this.documentId = this.$route.params.documentId
    this.fetchDocumentInfo()
    this.fetchCaseInfo()
    this.fetchMaterials()
    this.fetchParagraphs()
    this.checkLlmTaskStatusOnLoad()
  },
  methods: {
    fetchDocumentInfo() {
      request.get(`/api/document/${this.documentId}`).then(res => {
        const doc = Array.isArray(res.data) ? res.data[0] : res.data
        this.documentName = doc.documentName || '文书编辑'
        this.documentPath = doc.documentPath || ''
        if (this.documentPath) {
          this.getDocumentDownloadUrl()
        } else {
          this.documentFileUrl = ''
        }
      }).catch(() => {
        this.documentName = '文书编辑'
        this.documentPath = ''
        this.documentFileUrl = ''
      })
    },
    fetchCaseInfo() {
      if (!this.caseId) return
      request.get(`/api/case/${this.caseId}`).then(res => {
        if (res.data && res.data.caseName) {
          this.caseName = res.data.caseName
        } else {
          this.caseName = ''
        }
      }).catch(() => {
        this.caseName = ''
      })
    },
    fetchMaterials() {
      request.get(`/api/document/materials/${this.documentId}`).then(res => {
        this.materialList = res.data || []
        this.materialSelection = []
        this.fetchUnaddedMaterials()
      })
    },
    fetchUnaddedMaterials() {
      // 获取当前案件所有材料，过滤掉已添加的
      request.get(`/api/material/list/${this.caseId}`).then(res => {
        const all = res.data || []
        const addedIds = this.materialList.map(m => m.materialId)
        this.unaddedMaterialList = all.filter(m => !addedIds.includes(m.materialId))
      })
    },
    fetchParagraphs() {
      request.get(`/api/document/paragraphs/${this.documentId}`).then(res => {
        const paragraphs = res.data || []
        // 获取书签is_editable信息
        const templateId = paragraphs.length > 0 ? paragraphs[0].templateId : ''
        if (templateId) {
          request.get(`/api/template-bookmark/list?templateId=${templateId}`).then(bres => {
            const bookmarkMap = {}
            ;(bres.data || []).forEach(bk => { bookmarkMap[bk.bookmarkId] = bk })
            this.paragraphList = paragraphs.map(p => ({
              ...p,
              isEditable: bookmarkMap[p.bookmarkId] ? bookmarkMap[p.bookmarkId].isEditable : 0
            }))
          })
        } else {
          this.paragraphList = paragraphs
        }
      })
    },
    handleMaterialSelection(selection) {
      this.materialSelection = selection
    },
    handleMaterialRowClick(row, column, event) {
      // 行点击时选中/取消选中复选框
      this.$refs.materialTable.toggleRowSelection(row)
    },
    removeMaterialRow(row) {
      // 单行移除
      request.post(`/api/document/material/remove`, {
        documentId: this.documentId,
        materialIds: [row.materialId]
      }).then(() => {
        this.$message.success('移除成功')
        this.fetchMaterials()
      })
    },
    previewMaterial(row) {
      // 只预览，不高亮
      request.get(`/api/material/download/${row.materialId}`).then(res => {
        if (res.data) {
          this.previewFileUrl = res.data
          this.previewFileType = row.materialType || 'docx'
          this.previewFileTitle = row.materialName || ''
          this.showPreviewMaterialDialog = true
        }
      })
    },
    closePreviewMaterial() {
      this.showPreviewMaterialDialog = false
      this.previewFileUrl = ''
      this.previewFileType = ''
      this.previewFileTitle = ''
    },
    handleAddMaterialSelection(selection) {
      this.addMaterialSelection = selection
    },
    addSelectedMaterials() {
      if (!this.addMaterialSelection.length) {
        this.$message.error('请选择要添加的材料')
        return
      }
      const materialIds = this.addMaterialSelection.map(m => m.materialId)
      request.post(`/api/document/material/add`, {
        documentId: this.documentId,
        materialIds
      }).then(() => {
        this.$message.success('添加成功')
        this.showAddMaterialDialog = false
        this.fetchMaterials()
      })
    },
    rowClassName({ row }) {
      return row.materialId === this.currentMaterialId ? 'active-row' : ''
    },
    handleAddMaterial() {
      this.showAddMaterialDialog = true
      this.fetchMaterials()
    },
    goBack() {
      this.$router.push({ path: `/case/edit/${this.caseId}` })
    },
    editParagraph(row) {
      this.editingParagraph = row
      this.editingParagraphContent = row.paragraphContent || ''
      this.showEditParagraphDialog = true
      this.viewingParagraph = null
    },
    viewParagraph(row) {
      this.viewingParagraph = row
      this.editingParagraph = null
      this.showViewParagraphDialog = true
    },
    cancelEditParagraph() {
      this.editingParagraph = null
      this.editingParagraphContent = ''
      this.showEditParagraphDialog = false
    },
    cancelViewParagraph() {
      this.viewingParagraph = null
      this.showViewParagraphDialog = false
    },
    saveParagraphContent() {
      if (!this.editingParagraph) return
      const paragraphId = this.editingParagraph.paragraphId
      request.post(`/api/document/paragraph/update`, {
        paragraphId,
        paragraphContent: this.editingParagraphContent
      }).then(() => {
        this.$message.success('保存成功')
        this.editingParagraph = null
        this.editingParagraphContent = ''
        this.showEditParagraphDialog = false
        this.fetchParagraphs()
      })
    },
    async generateLlmDocument() {
      this.llmGenerating = true
      this.llmParagraphs = []
      this.llmReasoningList = []
      this.wsSessionId = this.documentId
      this.initWebSocket()
      try {
        const res = await request.get(`/api/document/llm-generate/${this.documentId}`)
        if (res.code === 200 && res.data) {
          this.llmTaskId = res.data
          this.pollLlmTaskStatus()
        } else {
          this.$message.error(res.message || '任务提交失败')
          this.llmGenerating = false
        }
      } catch (e) {
        this.$message.error('智能生成任务提交失败')
        this.llmGenerating = false
      }
    },
    initWebSocket() {
      if (this.ws) this.ws.close()
      try {
        const wsUrl = process.env.VUE_APP_WS_URL || 'ws://'+window.location.host+'/ws/notify'
        this.ws = new WebSocket(wsUrl)
      } catch (e) {
        console.error("initWebSocket error", e)
      }
      this.ws.onopen = () => {
        this.ws.send(JSON.stringify({ type: 'register', wsSessionId: this.wsSessionId }))
      }
      this.ws.onmessage = (event) => {
        this.llmReasoningList.push(event.data)
      }
      this.ws.onclose = () => {}
      this.ws.onerror = () => {}
    },
    pollLlmTaskStatus() {
      if (this.llmTaskTimer) clearInterval(this.llmTaskTimer)
      this.llmTaskTimer = setInterval(async () => {
        try {
          const res = await request.get(`/api/document/llm-task-status/${this.llmTaskId}`, { showLoading: false })
          if (res.code === 200 && res.data) {
            const status = res.data.status
            if (status === 'success') {
              clearInterval(this.llmTaskTimer)
              this.llmGenerating = false
              this.fetchDocumentInfo()
              this.fetchParagraphs()
              this.$message.success('文书生成成功')
            } else if (status === 'failed') {
              clearInterval(this.llmTaskTimer)
              this.llmGenerating = false
              this.$message.error('文书生成失败: ' + (res.data.error || ''))
            }
          }
        } catch (e) {
          clearInterval(this.llmTaskTimer)
          this.llmGenerating = false
          this.$message.error('轮询任务状态失败')
        }
      }, 2000)
    },
    downloadDocument() {
      if (!this.documentFileUrl) return
      window.open(this.documentFileUrl, '_blank')
    },
    async getDocumentDownloadUrl() {
      if (!this.documentPath) {
        this.documentFileUrl = ''
        return
      }
      try {
        const res = await request.get(`/api/document/download/${this.documentId}`)
        if (res.code === 200 && res.data) {
          this.documentFileUrl = res.data
        } else {
          this.documentFileUrl = ''
        }
      } catch (e) {
        this.documentFileUrl = ''
      }
    },
    async checkLlmTaskStatusOnLoad() {
      try {
        const res = await request.get(`/api/document/llm-task-status/${this.documentId}`)
        if (res.code === 200 && res.data) {
          const status = res.data.status
          if (status === 'pending' || status === 'running') {
            this.llmTaskId = this.documentId
            this.llmGenerating = true
            this.documentPath = '' // 强制隐藏文书内容，展示生成中样式
            this.pollLlmTaskStatus()
          }
        }
      } catch (e) {}
    },
    regenerateLlmDocument() {
      this.documentPath = ''
      this.documentFileUrl = ''
      this.generateLlmDocument()
    },
    getOnlyofficeCallbackUrl() {
      // 拼接callbackUrl，带上文书id和token
      const token = localStorage.getItem('token') || ''
      // 读取环境变量，未配置则用默认值
      const base = process.env.VUE_APP_ONLYOFFICE_CALLBACK
      return `${base}?documentId=${this.documentId}&token=${encodeURIComponent(token)}`
    },
  },
  computed: {
    filteredParagraphList() {
      if (this.showOnlyEditable) {
        return this.paragraphList.filter(p => p.isEditable === 1)
      }
      return this.paragraphList
    },
  },
  watch: {
    llmReasoningList() {
      this.$nextTick(() => {
        let el = this.$refs.llmReasoningStream;
        if (Array.isArray(el)) el = el[0];
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    }
  },
  beforeDestroy() {
    if (this.llmTaskTimer) clearInterval(this.llmTaskTimer)
  },
}
</script>

<style scoped>
.document-edit-root {
  background: #f5f7fa;
  min-height: 98vh;
  padding: 0;
}
.top-bar {
  width: 100%;
  height: 56px;
  background: linear-gradient(90deg, #409EFF 0%, #66b1ff 100%);
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(64,158,255,0.08);
  margin-bottom: 24px;
  border-radius: 0 0 10px 10px;
  position: relative;
}
.top-bar-title {
  color: #fff;
  font-size: 22px;
  font-weight: bold;
  margin-left: 32px;
  letter-spacing: 2px;
}
.top-bar-back {
  position: absolute;
  right: 32px;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}
.main-layout {
  display: flex;
  flex-direction: row;
  max-width: 100vw;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  min-height: 90vh;
  overflow: hidden;
}
.side-bar {
  width: 320px;
  border-right: 1px solid #e0e6ed;
  padding: 24px 12px 12px 12px;
  background: #fafbfc;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: calc(90vh - 24px);
  min-height: 600px;
}
.side-action-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.side-card {
  margin-bottom: 0;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(64,158,255,0.08);
  padding: 0 0 8px 0;
  background: #fff;
  border: none;
  flex-shrink: 0;
}
.material-section, .paragraph-section {
  padding: 8px 0 0 0;
}
.paragraph-table {
  flex: 1 1 0;
  min-height: 0;
}
.section {
  margin-bottom: 12px;
}
.section-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px;
  color: #409EFF;
}
.preview-area {
  flex: 1;
  padding: 24px 32px 24px 32px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
  background: #f8fafc;
}
.empty-preview {
  color: #bbb;
  font-size: 18px;
  text-align: center;
  margin-top: 120px;
}
.el-table__row.active-row {
  background: #e6f7ff !important;
}
.material-actions {
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  gap: 8px;
}
.edit-paragraph-form {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  padding: 24px 32px 16px 32px;
  margin: 0 auto;
}
.edit-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #409EFF;
}
.llm-generate-center-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}
.llm-generate-btn {
  font-size: 22px !important;
  padding: 18px 48px !important;
  border-radius: 32px !important;
  box-shadow: 0 4px 24px rgba(64,158,255,0.12);
  margin-bottom: 32px;
  letter-spacing: 2px;
}
.llm-generating-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f0f9ff;
  border: 1.5px solid #b3e5fc;
  border-radius: 24px;
  padding: 18px 36px;
  margin-top: 24px;
  font-size: 20px;
  color: #409EFF;
  box-shadow: 0 2px 12px rgba(64,158,255,0.08);
  animation: pulse 1.5s infinite;
  min-width: 480px;
  max-width: 900px;
}
.llm-loading-icon {
  font-size: 28px;
  margin-right: 16px;
  animation: spin 1s linear infinite;
}
.llm-generating-text {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 1px;
}
.llm-reasoning-card {
  min-height: 100px;
  max-height: 600px;
  padding: 0;
}
.llm-reasoning-stream {
  min-height: 200px;
  max-height: 500px;
  min-width: 480px;
  max-width: 850px;
  overflow-y: auto;
  padding: 12px 18px;
  font-family: 'Fira Mono', 'Consolas', 'Menlo', monospace;
  font-size: 15px;
  color: #ad8b00;
  word-break: break-all;
  white-space: pre-wrap;
  line-height: 1.2;
  letter-spacing: 0.5px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@keyframes pulse {
  0% { box-shadow: 0 2px 12px rgba(64,158,255,0.08); }
  50% { box-shadow: 0 6px 32px rgba(64,158,255,0.18); }
  100% { box-shadow: 0 2px 12px rgba(64,158,255,0.08); }
}
.doc-action-bar-static {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}
.paragraph-card {
  flex: 1 1 0 !important;
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: 100%;
}
.paragraph-section {
  display: flex;
  flex-direction: column;
  min-height: 38vh;
  height: 100%;
}
.paragraph-table-wrapper {
  flex: 1 1 0;
  min-height: 0;
  height: 100%;
  overflow: auto;
}
.paragraph-table {
  height: 100% !important;
}
.paragraph-dialog >>> .el-dialog__header {
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  font-size: 20px;
  font-weight: bold;
  color: #409EFF;
  letter-spacing: 1px;
}
.paragraph-dialog >>> .el-dialog__body {
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  font-size: 16px;
  color: #222;
  padding-top: 18px;
  padding-bottom: 0;
}
.paragraph-dialog-textarea >>> .el-textarea__inner {
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  font-size: 16px;
  color: #333;
  background: #f8fafc;
  border-radius: 6px;
  min-height: 320px;
  line-height: 1.6;
  padding: 14px 16px;
  box-shadow: 0 2px 8px rgba(64,158,255,0.04);
  border: 1px solid #e0e6ed;
  transition: border-color 0.2s;
}
.paragraph-dialog-textarea >>> .el-textarea__inner:focus {
  border-color: #409EFF;
  background: #fff;
}
.paragraph-dialog >>> .el-dialog__footer {
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  background: #f8fafc;
  border-top: 1px solid #f0f0f0;
  padding: 16px 24px 16px 24px;
}

/* 材料预览弹窗样式 */
.material-preview-dialog >>> .el-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.material-preview-dialog >>> .el-dialog__body {
  padding: 20px;
  background: #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
}

.material-preview-container {
  width: 85%;
  max-width: 900px;
  height: 85vh;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
}

.material-preview-container >>> .onlyoffice-wrapper {
  width: 100% !important;
  height: 100% !important;
}

.material-preview-container >>> .onlyoffice-content {
  width: 100% !important;
  height: 100% !important;
}

.material-preview-container >>> .onlyoffice-content > div {
  width: 100% !important;
  height: 100% !important;
}
</style> 